import React, { useEffect, useState } from 'react';
import { Button, TextField } from '@mui/material';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { CheckCircle } from '@mui/icons-material';
import { createAdminUserLabel, editAdminUserLabelById, onlyLabelColorsList, resetOnlyLabelColors } from '../redux/actions/userActions';

const customModalStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 1000,
        marginTop: '2em'
    },
    content: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '8px',
        maxWidth: '40%',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
    },
};

const AddLabelModal = ({ open, onClose, label, onNewLabelAdded }) => {
    const dispatch = useDispatch();
    const [labelText, setLabelText] = useState(label?.name);
    const [selectedColor, setSelectedColor] = useState(label?.color);
    const [isSaving, setIsSaving] = useState(false);

    const onlyLabelColors = useSelector(state => state.user.labelColors);

    useEffect(() => {
        dispatch(onlyLabelColorsList());
        return () => {
            dispatch(resetOnlyLabelColors());
        }
    }, []);

    const handleSaveLabel = async () => {
        if (labelText && selectedColor) {
            let bodyJson = {
                'name': labelText,
                'color': selectedColor
            };
            setIsSaving(true);

            if (label) {
                await dispatch(editAdminUserLabelById(label.id, bodyJson));
            } else {
                await dispatch(createAdminUserLabel(bodyJson));
                onNewLabelAdded();
            }
            setIsSaving(false);
            onClose();
        }

    }

    const handleSelectColor = (color) => {
        setSelectedColor(color);
    }

    const isNullOrEmpty = (str) => {
        return !(str && str.trim());
    }

    function onMouseEnter(event) {
        if (event.target.id == "mainDiv") {
            event.target.style.transform = 'scale(1.2)';
        }
    }
    function onMouseLeave(event) {
        if (event.target.id == "mainDiv") {
            event.target.style.transform = 'scale(1)';
        }
    }

    return (
        <>
            <ReactModal
                isOpen={open}
                onRequestClose={onClose}
                contentLabel="Add Label Modal"
                style={customModalStyles}
            >
                <div>

                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Add New Label:</div>
                    <TextField
                        placeholder='Label'
                        type="text"
                        size="small"
                        style={{ marginTop: '16px', width: '100%' }}
                        value={labelText}
                        onChange={(e) => setLabelText(e.target.value)}
                        autoFocus={true}
                    />

                    <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap', gap: '24px' }}>
                        {onlyLabelColors && onlyLabelColors.map(color =>
                            <div
                                id="mainDiv"
                                onClick={() => handleSelectColor(color)}
                                onMouseOver={onMouseEnter}
                                onMouseOut={onMouseLeave}
                                style={{
                                    border: selectedColor == color && '1px solid black',
                                    transition: 'all .3s ease-in-out',
                                    cursor: 'pointer',
                                    height: '40px',
                                    width: '40px',
                                    borderRadius: '10px',
                                    backgroundColor: color
                                }}
                            >
                                {selectedColor == color &&
                                    <span style={{ position: 'relative', top: '-10px', right: '-25px' }}>
                                        <CheckCircle />
                                    </span>
                                }
                            </div>
                        )}
                    </div>

                    <div style={{ marginTop: '24px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ width: '120px' }}
                            size='small'
                            variant='outlined'
                            onClick={onClose}
                        >Cancel</Button>
                        <Button
                            style={{ marginLeft: '12px', width: '120px' }}
                            size='small'
                            variant='contained'
                            onClick={handleSaveLabel}
                            disabled={isNullOrEmpty(labelText) || !selectedColor}
                        >{isSaving ? 'Saving' : 'Save'}</Button>

                    </div>

                </div>
            </ReactModal>
        </>
    );
};

export default AddLabelModal;
